import { useMemo } from "react"
import { Table } from "antd"
import type { ColumnsType } from "antd/es/table"
import type { Key } from "react"
import { DomainLv1, DomainLv1TableProps } from "../types"
import { TableActionColumn } from "@/components/TableActionColumn"
import { ID } from "@/types/common"

const DomainTable = ({
  domainLv1s,
  onEdit,
  onDelete,
  loading = false,
  selectedIds = [],
  onSelectionChange,
}: DomainLv1TableProps) => {
  const columns: ColumnsType<DomainLv1> = useMemo(
    () => [
      {
        title: "领域名称",
        dataIndex: "name",
        key: "name",
        width: 200,
        sorter: (a: DomainLv1, b: DomainLv1) =>
          a.name.localeCompare(b.name, "zh"),
      },
      TableActionColumn<DomainLv1>({
        onEdit,
        onDelete,
        deleteConfirmDescription: "确定要删除这个领域吗？",
        width: 150,
      }) as any,
    ],
    [onEdit, onDelete]
  )

  const rowSelection = onSelectionChange
    ? {
        selectedRowKeys: selectedIds,
        onChange: (selectedRowKeys: Key[]) => {
          onSelectionChange(selectedRowKeys as ID[])
        },
        getCheckboxProps: (record: DomainLv1) => ({
          name: record.name,
        }),
      }
    : undefined

  return (
    <Table
      columns={columns}
      dataSource={domainLv1s}
      rowKey="id"
      loading={loading}
      rowSelection={rowSelection}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
        pageSizeOptions: ["10", "20", "50", "100"],
      }}
      size="middle"
      showSorterTooltip={false}
    />
  )
}

export default DomainTable
